import React from "react";
import classes from "./BottomSheetBody.module.css";

const BottomSheetBody = ({ children, dropClass }) => {
    return (
        <div className={`${classes.BottomSheetBody} ${dropClass || ""}`}>
            {children}
        </div>
    );
};

export default BottomSheetBody;
